import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaceCoreModule } from '@evorait/pace-core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderModule } from '../header/header.module';
import { MainComponent } from './main.component';

@NgModule({
    declarations: [MainComponent],
    imports: [CommonModule, HeaderModule, RouterModule, PaceCoreModule.forChild(), TranslateModule.forChild()],
    exports: [MainComponent],
})
export class MainModule {}
